// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__fr6A8","text":"Empty_text__p5DqE"};